import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav(res.user?.role === "admin" ? "/admin" : "/account");
    else setError(res.error);
  };

  const inputCls = "w-full border-2 border-border px-4 py-3 font-mono text-sm focus:outline-none focus:border-primary";

  return (
    <div className="max-w-md mx-auto px-5 py-16 md:py-24" data-testid="login-page">
      <h1 className="font-anton text-5xl uppercase tracking-tighter mb-2">Sign In</h1>
      <p className="font-mono text-sm text-muted-foreground mb-8">Welcome back to the gear.</p>
      {error && <p className="border-2 border-primary bg-primary/10 text-primary font-mono text-xs p-3 mb-5" data-testid="login-error">{error}</p>}
      <form onSubmit={submit} className="space-y-4">
        <input type="email" required placeholder="EMAIL" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
        <input type="password" required placeholder="PASSWORD" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
        <button type="submit" disabled={busy} data-testid="login-submit" className="w-full bg-primary text-primary-foreground font-outfit font-bold uppercase tracking-widest text-sm py-4 border-2 border-border hover:bg-secondary hover:border-secondary hover:text-white transition-colors disabled:opacity-50">
          {busy ? "Signing in..." : "Sign In"}
        </button>
      </form>
      <p className="font-mono text-sm mt-6">
        No account? <Link to="/register" data-testid="go-register" className="text-primary font-bold underline">Create one</Link>
      </p>
    </div>
  );
}
